export const socials = {
    github: "https://github.com/harshitchaunal321",
    linkedin: "https://www.linkedin.com/in/harshitchaunal/",
    email: "harshitchaunal123@gmail.com",
    phone: "+91 7579205137",
    location: "Nainital, Uttarakhand, India",
    resume: "/assets/HarshitChaunalResume.pdf",
};

export const navLinks = [
    { id: "what", index: "01", title: "What I Do" },
    { id: "experience", index: "02", title: "Experience" },
    { id: "work", index: "03", title: "Work" },
    { id: "contact", index: "04", title: "Contact" },
];

/* The scripted brain behind the "ask me" chat */
export const chatIntro =
    "Hey! I'm ask.harshit — a tiny scripted agent that knows one person extremely well. Tap a prompt; I'll answer like a product briefing, not a brochure. ↓";

export const chatQuestions = [
    {
        id: "who",
        label: "Who is Harshit?",
        answer:
            "A senior software engineer from the hills of Nainital, India. For 5+ years he's built software end to end — React and React Native on the surface, Node.js and Spring Boot underneath, AWS holding it all up. These days he leads architecture, reviews the code that ships, and mentors the people who ship it.",
    },
    {
        id: "ai",
        label: "What's the AI part?",
        answer:
            "He treats LLMs as production components, not magic demos. Retrieval pipelines, research copilots, summarization, citation, drafting — wired with guardrails, fallbacks and evals so they survive real users. The AI Research Assistant below is the clearest example.",
    },
    {
        id: "rag",
        label: "How do you ship RAG?",
        answer:
            "Chunk → embed → retrieve → ground the prompt → generate → verify. He cares about citation fidelity, latency budgets and what happens when retrieval misses — graceful degradation beats a confident hallucination every time.",
    },
    {
        id: "prompts",
        label: "Prompt engineering — real skill?",
        answer:
            "Yes, when it's treated like API design: clear system roles, structured outputs, few-shot examples and eval harnesses. Prompting without tests is just vibes — he versions prompts the way he'd version any critical interface.",
    },
    {
        id: "built",
        label: "What has he built?",
        answer:
            "An AI Research Assistant (LLM pipeline for papers, summaries, citations and drafts), production client sites like Vyomic Space, and Midnight Pulse — a VS Code theme on the official Marketplace. Case studies are in the Work section. ↓",
    },
    {
        id: "stack",
        label: "What's the stack?",
        answer:
            "TypeScript, React and React Native up front. Node.js, Express and Spring Boot behind. DynamoDB, MongoDB and MySQL for data. AWS + Docker for shipping. LLM APIs and RAG tooling when the product needs a brain.",
    },
    {
        id: "vs-wrapper",
        label: "Just wrapping ChatGPT?",
        answer:
            "No. A thin wrapper is a weekend. Production AI is retrieval quality, cost control, rate limits, evals, UX for uncertainty and a plan when the model fails. He builds the system around the model — not a text box that calls an API.",
    },
    {
        id: "hire",
        label: "Is he available?",
        answer:
            "Selectively — for freelance and AI engineering work where the problem is genuinely interesting. The form at the bottom lands in his inbox; he usually replies within a day.",
    },
];

export const tickerItems = [
    "React", "Node.js", "TypeScript", "Java", "Spring Boot", "LLM Integration",
    "RAG Pipelines", "AWS", "Docker", "React Native", "DynamoDB", "MongoDB",
    "MySQL", "Express", "Redux", "System Design", "CI/CD", "Prompt Engineering",
];

export const capabilities = [
    {
        index: "a",
        title: "AI Engineering",
        focus: true,
        blurb: "LLM-powered products from prototype to production — retrieval, summarization, agents, and the evals that keep them honest.",
    },
    {
        index: "b",
        title: "Full-Stack Systems",
        blurb: "End-to-end web applications with clean contracts between a fast React front end and a robust Node or Spring Boot service layer.",
    },
    {
        index: "c",
        title: "Mobile Apps",
        blurb: "Cross-platform React Native apps that feel native — shipped to both stores with push, auth and offline handled.",
    },
    {
        index: "d",
        title: "Data & Infrastructure",
        blurb: "Schemas that survive scale and pipelines that deploy themselves. AWS-first, containerized, observable.",
    },
];

export const toolbox = [
    { name: "React", tone: "blue" },
    { name: "TypeScript", tone: "blue" },
    { name: "React Native", tone: "blue" },
    { name: "Redux", tone: "blue" },
    { name: "Node.js", tone: "green" },
    { name: "Express", tone: "green" },
    { name: "Java", tone: "orange" },
    { name: "Spring Boot", tone: "green" },
    { name: "LLM APIs", tone: "violet" },
    { name: "RAG", tone: "violet" },
    { name: "NLP", tone: "violet" },
    { name: "DynamoDB", tone: "orange" },
    { name: "MongoDB", tone: "green" },
    { name: "MySQL", tone: "orange" },
    { name: "AWS", tone: "orange" },
    { name: "Docker", tone: "blue" },
    { name: "Git", tone: "orange" },
    { name: "CI/CD", tone: "violet" },
];

export const experiences = [
    {
        title: "Senior Software Engineer",
        company: "Igniters Hub",
        date: "May 2024 — Present",
        tag: "current",
        stack: ["React", "Node.js", "DynamoDB", "AWS"],
        points: [
            "Lead design and development of scalable full-stack systems across React.js, Node.js and DynamoDB.",
            "Architect reusable component systems powering multiple dashboards and mobile apps.",
            "Own technical requirements with cross-functional teams; ship high-impact features on schedule.",
            "Run code reviews, mentor engineers and enforce architecture standards across projects.",
            "Integrate secure APIs and keep performance and reliability healthy at scale.",
        ],
    },
    {
        title: "Software Engineer",
        company: "Igniters Hub",
        date: "Oct 2021 — May 2024",
        stack: ["Node.js", "Spring Boot", "React", "Firebase"],
        points: [
            "Built and optimized RESTful APIs and microservices with Node.js, Express and Java (Spring Boot).",
            "Delivered complex front-end flows in React — reusable components, multi-step forms.",
            "Integrated AWS, Firebase and Strapi to expand product capabilities.",
            "Hardened security by closing vulnerabilities in authentication and API layers.",
        ],
    },
    {
        title: "Software Engineer Intern",
        company: "Igniters Hub",
        date: "Dec 2020 — Oct 2021",
        stack: ["Java", "Node.js", "Postman"],
        points: [
            "Developed RESTful APIs in Node.js and Java (Spring Boot) for backend services.",
            "Contributed fixes, docs and features across multiple live projects.",
            "Built fluency in version control, API testing and deployment workflows.",
        ],
    },
];

export const projects = [
    {
        index: "01",
        name: "AI Research Assistant",
        year: "2025",
        role: "AI Engineering · Full Stack",
        description:
            "An end-to-end research copilot: refines topics with gap analysis, searches academic databases, summarizes papers, generates citations, drafts content and checks plagiarism. Built as a full LLM pipeline — retrieval, synthesis and verification — behind a clean web interface.",
        tags: ["LLM Pipeline", "NLP", "RAG", "Full Stack"],
        image: process.env.PUBLIC_URL + "/assets/AIresearchassitant.png",
        source_code_link: "https://github.com/harshitchaunal321/AiResearchAssistant",
        live_link: "https://airesearchassistant-tefz.onrender.com/",
        highlights: [
            "Topic refinement with research-gap analysis",
            "Literature search across academic databases",
            "Summarization, citation generation & plagiarism checks",
        ],
    },
    {
        index: "02",
        name: "Vyomic Space",
        year: "2024",
        role: "Design Engineering · Client Work",
        description:
            "A production website for VyomIC, shipped end-to-end for a founding team — design system, motion, SEO and performance budgets included. It became the client's primary conversion channel.",
        tags: ["React", "Design System", "SEO", "Performance"],
        image: process.env.PUBLIC_URL + "/assets/vyomic.png",
        live_link: "https://www.vyomic.space/",
        highlights: [
            "Fully responsive, motion-driven interface",
            "Optimized loading and SEO-friendly structure",
        ],
    },
    {
        index: "03",
        name: "Midnight Pulse",
        year: "2024",
        role: "Developer Tooling · Design",
        description:
            "A dark VS Code theme with vibrant pulse accents, engineered for long focus sessions and published on the VS Code Marketplace — color theory applied to the tool engineers stare at all day.",
        tags: ["VS Code", "DX", "Color Theory"],
        image: process.env.PUBLIC_URL + "/assets/vscodethemeimage.png",
        source_code_link: "https://github.com/harshitchaunal321/midnight-pulse",
        live_link: "https://marketplace.visualstudio.com/items?itemName=harshitchaunal321.midnight-pulse",
        highlights: [
            "Published on the VS Code Marketplace",
            "Tuned contrast for readability in long sessions",
        ],
    },
];

export const testimonial = {
    quote:
        "Harshit delivered an outstanding website for VyomIC that exceeded our expectations. His attention to detail, modern design approach, and seamless execution made the entire process smooth. The website is not only visually stunning but also performs flawlessly across all devices.",
    name: "Lokesh Kabdal",
    designation: "Co-founder & CEO, VyomIC",
};